<template>
  <!-- 选择联系人、网点 -->
  <div
    class="p-absolute left-0 bottom-0 w-100-p bg-white"
    :class="{
      'top-51': $root.$children[0].activeTab === 'message' || $root.$children[0].activeTab === 'contact',
      'top-0': $root.$children[0].activeTab === 'notification'
    }"
    :style='{
      "padding-top":$root.$children[0].activeTab == "message" || $root.$children[0].activeTab == "notification" ? 0 : "39px"
    }'>
    <div class="p-absolute top-0 left-0 w-100-p h-39 b-b b-c-g-100" v-if="$root.$children[0].activeTab == 'contact'">
      <ul class="d-table w-100-p h-100-p">
        <li class="p-relative d-table-cell h-100-p t-a-center v-a-middle cursor-default user-select-none c-blue-hover" :style="{width:100/tabs.length+'%'}" v-for="item in tabs" :key="item.value" :class="{'c-blue':navSelctType===item.value}">
          <label>{{item.name}}<input class="d-none" type="radio" :value="item.value" name="imNavTabRadio" v-model="navSelctType"></label>
          <i class="d-none p-absolute left-0 right-0 m-auto h-2" :class="{'d-block':navSelctType===item.value}" style="bottom: -1px; background-color: #653EB3;" :style="{width:item.labelWidth}"></i>
        </li>
      </ul>
    </div>
    <!-- 最近聊天 -->
    <template v-if="$root.$children[0].activeTab == 'message'">
      <div class="h-100-p o-auto left-personnel-box" v-show="navSelctType==='3'" id="sessionListBox">
        <im-session-list :width="width" :im="im" :sessions="sessions" :to-account="toaccounts" @updatesessions="updatesessions"  @deleteLocalSession="deleteLocalSession" @deleteLocalMsgsBySession="deleteLocalMsgsBySession" @addStickTopSession="addStickTopSession"/>
        <div style="text-align:center; padding:5px;" v-show="contactLoading"><img src="@/assets/images/im/loading_button.gif" width="16"></div>
        <p class="c-g-200 t-a-center p-y-10" v-show="contactItems.length===0 && !contactLoading">没有匹配到组织</p>
      </div>
    </template>
    <template v-if="$root.$children[0].activeTab == 'contact'">
      <!-- 通讯录 navSelctType 只能取到 0, 1, 2 -->
      <!-- 网点 -->
      <div class="h-100-p o-auto left-personnel-box" v-show="navSelctType==='0'">
        <im-kcode-list :width="width" :items="kcodeItems"  @createSession="createSession"  v-if="kecodeflag" :codeflag="kecodeflag" />
        <div class="p-5 t-a-center b-b b-c-g-100" v-show="contactLoading"><img src="@/assets/images/im/loading_button.gif" width="16"></div>
        <p class="c-g-200 t-a-center p-y-10 b-b b-c-g-100" v-show="kcodeItems.length===0 && !contactLoading">没有匹配到网点</p>
      </div>
      <!-- 组织 -->
      <div class="h-100-p o-auto left-personnel-box" v-show="navSelctType==='1'">
        <im-kecontact-list :width="width" :items="contactItems" @createSession="createSession" />
        <div style="text-align:center; padding:5px;" v-show="contactLoading"><img src="@/assets/images/im/loading_button.gif" width="16"></div>
        <p class="c-g-200 t-a-center p-y-10" v-show="contactItems.length===0 && !contactLoading">没有匹配到组织</p>
      </div>
      <!-- 群组 -->
      <div class="h-100-p o-auto left-personnel-box" v-show="navSelctType==='2'" v-if="!toAddGroupFlag">
        <im-group-list :width="width" :items="teamCurrentList" @createSessionGroup="createSessionGroup" v-if="groupFlag"/>
        <div style="text-align:center; padding:5px;" v-show="contactLoading"><img src="@/assets/images/im/loading_button.gif" width="16"></div>
        <p class="c-g-200 t-a-center p-y-10" v-show="teamCurrentList.length===0 && !contactLoading">没有匹配到群组</p>
      </div>
    </template>
    <!-- 系统通知 -->
    <template v-if="$root.$children[0].activeTab == 'notification'">
      <div
        @click="clickNotificationType(item)"
        v-for="(item, idx) in msgList"
        :key="idx"
        class="flex align-items-center justify-content-between msgitem w-100-p h-50 b-b b-c-g-100 cursor-default bg-g-50-hover">
        <div class="flex align-items-center">
          <img class="msgicon" :src="item.icon" alt="">
          <span class="m-l-10 f-w-700">{{ item.msgTitle }}</span>
          <span class="numstyle" v-if="item.total">{{ item.total }}</span>
        </div>
        <span class="msgtime">{{ lastMsgTime }}</span>
      </div>
    </template>
  </div>
</template>
<script>
import imSessionList from './im-session-list.vue';
import imKcodeList from './im-kcode-list.vue';
import imKecontactList from './im-kecontact-list.vue';
import imGroupList from './im-group-list.vue';
import { dateFormat } from '@/utils/util';
export default {
  props: {
    im: {
      type: Object,
      default: function () {
        return {}
      }
    },
    sceneCp:{
      type: String,
      default: ''
    },
    sessions: {
      type: Array,
      default: function () {
        return [];
      }
    },
    teamCurrentList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    toaccounts: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    orgcode: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 250
    },
    togroup: {
      type: Number,
      default: 0
    },
    notificationList: {
      type: [Array, Object]
    }
  },
  data: function () {
    return {
      tabs: [
        // { value: '3', name: '最近聊天', labelWidth: '33px' },
        { value: '0', name: '网点', labelWidth: '33px' },
        { value: '1', name: '我的组织', labelWidth: '34px' },
        { value: '2', name: '群聊', labelWidth: '33px' }
      ],
      // 选择tab类型,0 全部、1 联系人、2 网点
      navSelctType: '3',
      contactItems: [],
      contactItemsShort: [],
      contactLoading: false,
      contactPointItems: [],
      contactPointItemsShort: [],
      contactPointLoading: false,
      kecodeflag: false,
      groupFlag: false,
      historyList: [],
      groupId:'',
      kcodeItems: [
        // {orgName: '上海市静安区静安门', orgCode: '', kCode: 'K11132734', kName: '测试1'},
        // {orgName: '上海市闵行区七宝', orgCode: '', kCode: 'K47112920', kName: '测试2'},
        // {orgName: '上海市静安区静安门', orgCode: '', kCode: 'K47112924', kName: '测试3'},
        // {orgName: '上海市闵行区七宝', orgCode: '', kCode: 'K24064848', kName: '测试4'},
        // {orgName: '上海市静安区静安门', orgCode: '', kCode: 'K79149632', kName: '测试5'}
      ],
      groupList:[],
      toAddGroupFlag:false,
      curMsgType: '3015', // 当前选中的消息类型 默认 系统提示
      msgList: [
        {
          msgType: '3015',
          subType: '30150002',
          fromAccid: '999993015',
          msgTitle: '系统提醒',
          icon: require('@/assets/images/im/tixing.png')
        },
        {
          msgType: '3016',
          subType: '30160001',
          fromAccid: '999993016',
          msgTitle: '买家地址异常处理',
          icon: require('@/assets/images/im/abnormal-address-icon@2x.png')
        },
      ],
    };
  },
  components: {
    // 会话列表
    imSessionList,
    imKcodeList,
    // 选择联系人
    imKecontactList,
    imGroupList
  },
  created: function () {
    this.getCustomerInfo();
    this.getGroupId();
    // 点击添加群组时弹出框不显示群组tab
    // this.noSHowGroup();
    // var grounId = newUserinfo?JSON.parse(newUserinfo):{};
    // var currentGrounId = grounId.groupId?grounId.groupId:'';
    // this.groupId = currentGrounId;
  },
  mounted:function () {
    this.queryContacts();
    var self = this;
    setTimeout(function () {
      self.groupFlag = true;
      self.groupList = sessionStorage.getItem("teamslist")?JSON.parse(sessionStorage.getItem("teamslist")):[];
    },1000);
    // this.getGroupList();
    this.bus.$on("msgOnDoubleClick",()=>{
      self.scrollToTop();
    })
  },
  computed: {
    groupListCurrent: function () {
      this.groupList = sessionStorage.getItem("teamslist")?JSON.parse(sessionStorage.getItem("teamslist")):[];
    },
    activeTab(){
      return this.$root.$children[0].activeTab
    },
    lastMsgTime() {
      if(this.notificationList && this.notificationList.total > 0) {
        const todayStart = new Date(new Date().setHours(0,0,0,0)).getTime(), // 今天的开始 || 昨天的结束
              todayEnd = new Date(new Date().setHours(24,0,0,0)).getTime(), // 今天的结束
              yesterdayStart = new Date(new Date().setHours(0,0,0,0)).getTime() - 24 * 60 * 60 * 1000, // 昨天的开始
              lastMsgTime = this.notificationList.list[0].createTimeStamp;
        
        if(lastMsgTime > todayStart && lastMsgTime < todayEnd) {
          return dateFormat(new Date(lastMsgTime), 'hh:mm')
        } else if(lastMsgTime > yesterdayStart && lastMsgTime <= todayStart) {
          return '昨天'
        } else {
          return dateFormat(new Date(lastMsgTime), 'MM-dd')
        }
      }
    }
  },
  methods: {
    clickNotificationType(item) {
      // 点击系统通知的消息类型
      this.curMsgType = item.msgType;
      this.$set(item,'total',0);
      this.$forceUpdate();
      // 把curMsgType通过 im-layout 父组件 传递给im-notification组件
      this.$emit('clickNotificationType', item);
    },
    updatesessions(item){
      this.$emit('updatesessions',item);
    },
    // 重置会话未读数为0
    resetSessionUnread: function (sessionId) {
      var item = this.sessions.filter(function (element) {
        return element.id === sessionId;
      })[0];
      if (!item || item.unread === 0) return;
      if (this.sceneCp === 'p2p' || this.sceneCp === 'team') {
        // im.resetSessionUnread 重置会话未读数为0, 会触发自己的会话列表更新
        this.im.resetSessionUnread(sessionId);
        this.updateReadStatus(item.chatRecordStore);
      }
    },
    // 更变聊天对话人 更新右侧对话框主题显示内容
    updateChatContact: function (session) {
      console.log("更变聊天对话人",session)
      this.toAccount = session.id;
      this.chatContentStore = session.chatRecordStore;
    },
    // 删除所有本地消息
    // this.im.deleteAllLocalMsgs({done: function(){}});
    // 删除某个会话的本地消息
    deleteLocalMsgsBySession: function (item) {
      // console.log("layout",item);
      var $this = this;
      this.im.deleteLocalMsgsBySession({
        scene: item.scene,
        to: item.to,
        // 是否同时删除本地会话对象中的lastMsg
        delLastMsg: true,
        done: function (error, data) {
          if (error) return;
          $this.resetSessionUnread(item.id);
          item.chatRecordStore.splice(0, item.chatRecordStore.length);
        }
      });
    },
    // 删除某个本地会话
    deleteLocalSession: function (session) {
      this.$emit('deleteLocalSession', session);
    },
    //置顶会话
    addStickTopSession:function (session){
      let $this = this;
      console.log("session.id", session.id);
      this.im.addStickTopSession({
        id: session.id,
        done: function (error) {
          console.log("error", error);
          $this.im.getStickTopSessions({
            done: function (error, data) {
              console.log("error", error, data);
            }
          })
        }
      });
      console.log(11);
    },
    // 点击联系人
    contactItemClickEvent: function (session) {
      this.$parent.contactItemClickEvent(session)
    },
    // 点击添加群组搜索框时不显示群组tab
    noSHowGroupTo: function () {
      var that = this;
      this.bus.$off("toAddGroup").$on("groupTofoucs",function(val){
        // console.log("groupTofoucsgroupTofoucs",val)
        if(val){
          that.tabs = [
            { value: '3', name: '最近聊天', labelWidth: '33px' },
            { value: '0', name: '网点', labelWidth: '33px' },
            { value: '1', name: '组织', labelWidth: '34px' }
          ]
        }
      });
    },
     // 点击添加群组时弹出框不显示群组tab
    noSHowGroup: function () {
      var that = this;
      this.bus.$off("groupTofoucs").$on('toAddGroup',function (val) {
        if(val === "toAddGroup"){
          that.toAddGroupFlag = val;
          that.tabs = [
            { value: '3', name: '最近聊天', labelWidth: '33px' },
            { value: '0', name: '网点', labelWidth: '33px' },
            { value: '1', name: '组织', labelWidth: '34px' }
          ]
        }
      });
    },
    getGroupList: function () {
      var $this = this;
      this.bus.$on('teamlist', function(msg){ 
        // console.log("666777",msg);
        if(msg){
          $this.groupList = msg;
          // $this.groupFlag = true;
        }
      });
    },
    getList: function (msg) {
      this.groupList = msg;
      this.groupFlag = true;
    },
    // 获取cookie
    getCookie: function (name) {
      var strcookie = document.cookie;//获取cookie字符串
      var arrcookie = strcookie.split("; ");//分割
      //遍历匹配
      for ( var i = 0; i < arrcookie.length; i++) {
          var arr = arrcookie[i].split("=");
          if (arr[0] == name){
              return arr[1];
          }
      }
      return "";
    },
    getGroupId: function () {
      this.getCookie('userInfo');
      var userinfo = this.getCookie('userInfo');
      var newUserinfo = userinfo.replace(/\%22/g,'');
      var newUserinfoTemp = newUserinfo.replace(/\%2C/g,",");
      var userArr = newUserinfoTemp.split(",");
      if(userArr.length > 0) {
        for(var i = 0; i < userArr.length; i++) {
          if(userArr[i].indexOf("groupId") > -1) {
            this.groupId = userArr[i].split(":")[1];
            break;
          }
        }
      }
    },
    getCustomerInfo: function () {
      this.contactLoading = true;
      var $this = this;
      this.kcodeItems = [];
      axiosHttpIm.post('/webIM/getCustomerInfo').then(
        function (response) {
          if (response.success && response.data) {
            if (response.data.bindKCodes) {
              $this.$nextTick(function () {
                this.contactLoading = false;
                this.kcodeItems = response.data.bindKCodes;
                // this.$refs.child.init(this.kcodeItems);
                this.kecodeflag = true;
              });
            }
          } else if (!response.success) {
            // 这里说明请求k码的接口调用失败
          }
        },
        function () {
          $this.contactLoading = false;
        }
      );
    },
    queryContacts: function () {
      this.contactLoading = true;
      this.contactItems = [];
      this.contactItemsShort = [];
      var $this = this;
      axiosHttpIm.post('/webGroups/getEmployeeInfo', {
        groupId:$this.groupId
      },{
        headers:{
          'jwt-token':window.im_store_const.token
        }
      }).then(
        function (response) {
          // if (response.payload.keyWord !== $this.value) return;
          $this.contactLoading = false;
          var data = response.data || {};
          $this.contactItems = data || [];
          
          $this.contactItemsShort = $this.contactItems.slice(0, 3);
        },
        function () {
          $this.contactLoading = false;
        }
      );
    },
    queryPoints: function () {
      this.contactPointLoading = true;
      this.contactPointItems = [];
      this.contactPointItemsShort = [];

      var $this = this;
      axiosHttpIm.post('/netEasyIM/getIMUserList', {
        keyWord: this.value,
        loginStationCode: this.orgcode,
        pageNum: 1,
        pageSize: 50,
        type: '1'
      }).then(
        function (response) {
          if (response.payload.keyWord !== $this.value) return;
          $this.contactPointLoading = false;
          var data = response.resultData.data || {};
          data = data.stationList || [];
          data.forEach(function (element) {
            element.children = [];
            element.loading = false;
          });
          $this.contactPointItems = data;
          $this.contactPointItemsShort = $this.contactPointItems.slice(0, 3);
        },
        function () { $this.contactPointLoading = false; }
      );
    },
    createSession: function (user) {
      this.$emit('createSession', user);
      this.addContactHistoryItem(user);
      this.navSelctType = '3';
    },
    createSessionGroup: function (user) {
      this.$emit('createSessionGroup', user);
      this.addContactHistoryItem(user);
      this.navSelctType = '3';
    },
    destroy: function () {
      this.$emit('destroy');
    },
    // 记录历史最近联系人 ----------------------------------------------------------------------------------
    // 添加联系人列表
    addContactHistoryItem: function (user) {
      var contactListlocal = localStorage.getItem(this.id + 'contactListlocal') || '[]';
      contactListlocal = JSON.parse(contactListlocal);

      var index = -1;
      contactListlocal.forEach(function (element, i) {
        if (element.userCode === user.userCode) {
          index = i;
        }
      });

      if (index === -1) {
        if (contactListlocal.length >= 10) contactListlocal.pop();
        contactListlocal.unshift(user);
        localStorage.setItem(this.id + 'contactListlocal', JSON.stringify(contactListlocal));
        this.historyList = contactListlocal;
      }
    },
    // 删除全部联系人
    delAllContactHistory: function () {
      this.historyList.splice(0, this.historyList.length);
      localStorage.setItem(this.id + 'contactListlocal', '[]');
    },
    scrollToTop(){
      document.getElementById("sessionListBox").scrollTop = 0;
    },
    getMsgTotalByType(){
      // console.log('notificationList-22',this.notificationList)
      this.msgList.map(msgItem=>{
        let total = this.notificationList.list.filter(item=> msgItem.msgType == item.msgType).length
        msgItem.total = total
      })
    }
  },
  watch: {
    value: function (val) {
      if (val) {
        // this.getCustomerInfo();
        this.queryContacts();
        // this.queryPoints();
      }
    },
    id: {
      handler: function (val) {
        if (val) {
          var contactListlocal = localStorage.getItem(this.id + 'contactListlocal') || '[]';
          this.historyList = JSON.parse(contactListlocal);
        }
      },
      immediate: true
    },
    activeTab(val){
      const hash={
        contact: "0",
        message: "3"
      };
      this.navSelctType = hash[val];
    },
    notificationList:{
      handler: function(val){
        // console.log('notificationList-11',val)
        val.total && this.getMsgTotalByType();
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.msgitem {
  padding: 0 20px;
}
.numstyle {
  background-color: #DE614C;
  height: 16px;
  min-width: 16px;
  padding: 0 3px;
  font-size: 12px;
  border-radius: 10px;
  color: #fff;
  text-align: center;
  line-height: 16px;
  margin-left: 15px;
}
.msgicon {
  height: 20px;
  width: auto;
}
.msgtime {
  color: #BFC1C2;
  font-size: 12px;
}
</style>
